import React, { useEffect, useRef, useState } from "react";
import { apiCall } from "../../../../utils/axiosService";
import { apiResponse } from "../../../../utils/apiResponse";
import { commonService } from "../../../../utils/commonService";
import { API_URL } from "../../../../utils/apiRoutes";
import moment from "moment";
import Loader from "../../../Loader/Loader";
import DatePicker from "react-datepicker";
import {
  Chart,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { Form, Table } from "react-bootstrap";
import Star from "../../../../Assets/Images/Revenue-management/star.svg";
import { useSelector } from "react-redux";

const GoogleRatings = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty.propertyDetail
  );
  //   const date = new Date();
  //   const startDate = new Date(date.getFullYear(), date.getMonth(), 1);
  //   // const endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  //   const endDate = new Date(date.setDate(date.getDate() - 1));
  const date = new Date();
  const endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const startDate = new Date(date.getFullYear(), date.getMonth() - 11, 1);

  const [startRangeDate, setStartRangeDate] = useState(startDate);
  const [endRangeDate, setEndRangeDate] = useState(endDate);
  const [loading, setLoading] = useState(false);
  const [ratingFrom, setRatingFrom] = useState(null);
  const [selectedRatingFrom, setSelectedRatingFrom] = useState();
  const [chartData, setChartData] = useState(null);
  const ratingDataObjRef = useRef();
  const datesArrRef = useRef();
  const [propertyWiseRating, setPropertyWiseRating] = useState(null);

  const getRatingsData = async () => {
    setLoading(true);
    let ratingsDataResponse = await apiCall(
      {
        method: "POST",
        url: API_URL.BASE_API_URL.SnapShot + API_URL.ANALYTICS.GOOGLE_RATINGS,
        body: {
          startDate: commonService.getDateForNode(startRangeDate),
          endDate: commonService.getDateForNode(endRangeDate),
          //   startDate: "2023-09-01",
          //   endDate: "2024-10-31",
          propertyCode: para?.propertyCode,
        },
      },
      false
    );

    let response = apiResponse(false, ratingsDataResponse);

    if (response?.isValidate) {
      let ratingfrom = [],
        ratingFromObj = {},
        dataFromApi = response?.data?.data,
        propertyObjForRatingTbl = {};

      //   let datesArr = commonService.getDateBetweenTwoDates(
      //     new Date(startRangeDate),
      //     new Date(endRangeDate)
      //   );
      //   datesArrRef.current = datesArr;

      let labels = [],
        datasets = [],
        propertyObj = {};

      dataFromApi?.forEach((item) => {
        if (!ratingFromObj[item?.ratingfrom]) {
          ratingfrom.push(item?.ratingfrom);
          ratingFromObj[item?.ratingfrom] = {};
        }

        if (!propertyObjForRatingTbl[item?.propertyname]) {
          propertyObjForRatingTbl[item?.propertyname] = {};
        }

        if (!propertyObj[item?.propertyname]) {
          propertyObj[item?.propertyname] = [];
          datasets.push({
            type: "line",
            label: item?.propertyname,
            data: [],
            fill: false,
            backgroundColor: commonService.CreateColor(item?.propertyname)
              ?.BGColor,
            borderColor: commonService.CreateColor(item?.propertyname)?.BGColor,
            borderWidth: 2,
            pointRadius: 1,
            pointBorderWidth: 4,
          });
        }
      });

      ratingFromObj = {};
      ratingfrom?.forEach((item) => {
        let groupingJson = {};
        Object.keys(propertyObj)?.forEach((propertyItem) => {
          groupingJson[`${propertyItem}//${item}`] = [];
        });
        ratingFromObj[item] = groupingJson;
      });

      //   datesArr?.forEach((item) => {
      //     labels.push(moment(item).format("MM/DD"));
      //     let findData = dataFromApi?.filter(
      //       (x) =>
      //         commonService.getDateInFormat(x?.dates) ===
      //         commonService.getDateInFormat(item)
      //     );
      //     if (findData?.length > 0) {
      //       let dummyObj = {};
      //       findData?.forEach((findDataItem) => {
      //         let findByPropertyName = findData?.filter(
      //           (x) => x?.propertyname === findDataItem?.propertyname
      //         );
      //         if (findByPropertyName?.length === ratingfrom?.length) {
      //           ratingFromObj[findDataItem?.ratingfrom][
      //             `${findDataItem?.propertyname}//${findDataItem?.ratingfrom}`
      //           ]?.push(findDataItem?.rating);
      //         } else {
      //           if (!dummyObj[findDataItem?.propertyname]) {
      //             ratingfrom?.forEach((ratingItem) => {
      //               let findValue = findByPropertyName?.filter(
      //                 (x) => x?.ratingfrom === ratingItem
      //               );
      //               if (findValue?.length > 0) {
      //                 ratingFromObj[ratingItem][
      //                   `${findDataItem?.propertyname}//${ratingItem}`
      //                 ]?.push(findDataItem?.rating);
      //               } else {
      //                 ratingFromObj[ratingItem][
      //                   `${findDataItem?.propertyname}//${ratingItem}`
      //                 ]?.push(0);
      //               }
      //             });
      //           }
      //           dummyObj[findDataItem?.propertyname] = findDataItem?.propertyname;
      //         }
      //       });
      //     } else {
      //       Object?.entries(ratingFromObj)?.forEach(([key, value], index) => {
      //         Object.keys(value)?.forEach((valueItem) => {
      //           ratingFromObj[key][`${valueItem}`]?.push(0);
      //         });
      //       });
      //     }
      //   });

      let dateForChart = startRangeDate;
      for (let i = 0; i < 12; i++) {
        let updatedDate = moment(dateForChart).add(i, "M");
        labels.push(updatedDate?.format("MMM/YYYY"));

        let findData = dataFromApi?.filter(
          (x) =>
            x?.month_name?.trim()?.toLowerCase() ===
            updatedDate?.format("MMMM")?.toLowerCase()
        );
        if (findData?.length > 0) {
          let dummyObj = {};
          findData?.forEach((findDataItem) => {
            let findByPropertyName = findData?.filter(
              (x) => x?.propertyname === findDataItem?.propertyname
            );
            if (findByPropertyName?.length === ratingfrom?.length) {
              ratingFromObj[findDataItem?.ratingfrom][
                `${findDataItem?.propertyname}//${findDataItem?.ratingfrom}`
              ]?.push(findDataItem?.average_rating);
            } else {
              if (!dummyObj[findDataItem?.propertyname]) {
                ratingfrom?.forEach((ratingItem) => {
                  let findValue = findByPropertyName?.filter(
                    (x) => x?.ratingfrom === ratingItem
                  );
                  if (findValue?.length > 0) {
                    ratingFromObj[ratingItem][
                      `${findDataItem?.propertyname}//${ratingItem}`
                    ]?.push(findDataItem?.average_rating);
                  } else {
                    ratingFromObj[ratingItem][
                      `${findDataItem?.propertyname}//${ratingItem}`
                    ]?.push(0);
                  }
                });
              }
              dummyObj[findDataItem?.propertyname] = findDataItem?.propertyname;
            }
          });
        } else {
          Object?.entries(ratingFromObj)?.forEach(([key, value], index) => {
            Object.keys(value)?.forEach((valueItem) => {
              ratingFromObj[key][`${valueItem}`]?.push(0);
            });
          });
        }
      }
      ratingDataObjRef.current = ratingFromObj;

      setSelectedRatingFrom(ratingfrom[0]);
      datasets = datasets?.map((dataSetItem) => {
        dataSetItem.data =
          ratingFromObj[ratingfrom[0]][
            `${dataSetItem?.label}//${ratingfrom[0]}`
          ];
        return dataSetItem;
      });

      Object?.entries(ratingFromObj)?.map(([key, value]) => {
        Object?.entries(value)?.map(([nestedKey, nestedValue]) => {
          let total = 0,
            avgCount = 0;
          nestedValue?.forEach((valueItem) => {
            total = total + (valueItem ? parseFloat(valueItem) : 0);
            if (valueItem) {
              avgCount = avgCount + 1;
            }
          });
          let splitName = nestedKey?.split("//");
          propertyObjForRatingTbl[splitName?.[0]] = {
            ...propertyObjForRatingTbl[splitName?.[0]],
            [splitName?.[1]]: Math.round(total / avgCount),
          };
        });
      });

      setChartData({
        labels,
        datasets,
      });
      setRatingFrom(ratingfrom);
      setSelectedRatingFrom(ratingfrom?.[0]);
      setPropertyWiseRating(propertyObjForRatingTbl);
      setLoading(false);
    }

    if (!response?.isValidate) {
      setChartData(null);
      setLoading(false);
    }
  };

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartRangeDate(start);
    setEndRangeDate(end);
  };

  useEffect(() => {
    if (api === 0) {
    } else {
      if (startRangeDate && endRangeDate) {
        getRatingsData();
      }
    }
  }, [startRangeDate, endRangeDate]);

  const handleRatingFromOnChange = (selectedValue) => {
    let data = chartData?.datasets;
    let updatedDataSet = data?.map((item) => {
      item.data =
        ratingDataObjRef.current[selectedValue][
          `${item?.label}//${selectedValue}`
        ];
      return item;
    });
    setChartData({
      ...chartData,
      datasets: updatedDataSet,
    });
  };

  const handleStar = (value) => {
    if (value) {
      let dummyArr = Array(value).fill(0);
      return (
        <div>
          {dummyArr?.map((item) => {
            return <img style={{ height: "15px" }} src={Star} />;
          })}
        </div>
      );
    }
  };

  const chartOptions = {
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        enabled: true,
        mode: "index",
        callbacks: {
          title: function (context) {
            return context[0].label;
          },
          label: function (context) {
            let label = context.dataset.label;
            let value = context.formattedValue;
            return `${label}: ${value}`;
          },
        },
      },
    },
  };

  Chart.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    PointElement,
    LineElement,
    Filler
  );

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <>
          {propertyWiseRating && (
            <div className="table__container">
              <div className="stripped__table">
                <div className="table-responsive">
                  <Table>
                    <thead className="tbl-header-sticky my-tbl-header-sticky">
                      <tr>
                        {Object?.entries(propertyWiseRating)?.map(
                          ([key, value], index) => {
                            if (index === 0) {
                              return (
                                <>
                                  <th>Property</th>
                                  {Object?.entries(value)?.map(
                                    ([nestedKey, nestedValue]) => {
                                      return (
                                        <th className="width100">
                                          {nestedKey}
                                        </th>
                                      );
                                    }
                                  )}
                                </>
                              );
                            }
                          }
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr style={{ height: "80px", position: "relative" }}>
                          <Loader />
                        </tr>
                      ) : propertyWiseRating ? (
                        Object?.entries(propertyWiseRating)?.map(
                          ([key, value]) => {
                            let isSelfProperty = false;
                            if (key === propertyDetailFromRTK?.propertyname) {
                              isSelfProperty = true;
                            }
                            return (
                              <tr key={key} className="shadowOnHover">
                                <td
                                  className={`${isSelfProperty && "fontBold"}`}
                                >
                                  {key}
                                </td>
                                {Object?.entries(value)?.map(
                                  ([nestedKey, nestedValue]) => {
                                    return <td>{handleStar(nestedValue)}</td>;
                                  }
                                )}
                              </tr>
                            );
                          }
                        )
                      ) : (
                        <tr>
                          <td>No Data found</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          )}
          <div
            style={{ display: "flex", alignItems: "center", gap: "10px" }}
            className="mt-3"
          >
            {/* <div className="width175">
              <DatePicker
                onChange={(event) => handleDateChange(event)}
                startDate={startRangeDate}
                endDate={endRangeDate}
                maxDate={new Date()}
                selectsRange
                monthsShown={2}
              />
            </div> */}
            <div className="from-groups no-border-break width150">
              <Form.Select id={commonService.generateGlobalClickTrackerID("GoogleRatings", "form-select-onchange", "")}
                aria-label="Default select example"
                value={selectedRatingFrom}
                onChange={(e) => {
                  setSelectedRatingFrom(e.target.value);
                  handleRatingFromOnChange(e.target.value);
                }}
              >
                {ratingFrom?.map((item) => {
                  return (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  );
                })}
              </Form.Select>
            </div>
          </div>
          {chartData ? (
            <div style={{ height: "400px" }}>
              <Line data={chartData} options={chartOptions} />
            </div>
          ) : (
            <div className="d-flex justify-content-center">
              <p>No Data Found</p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default GoogleRatings;
